import * as Sentry from '@sentry/browser';

export class Tracer {

    constructor(){

    }

    tag(name, value){

        if (name == null)return;
        if (value == null){
            value = "";
        }

        console.debug(`[d-963795] (tag) ${name}:${value}`);
        try {
            if (!window.config.isLocal) {
                Sentry.setTag(name, value);
            }
        }
        catch(error){
            console.error(error);
        }
    }

    httpError(error){


        try {
            if (error == null) {
                return;
            }

            let response = error.response;
            if (response == null) {
                return;
            }

            if (response.status === 200 ||
                response.status === 201 ||
                response.status === 202 ||
                response.status === 204 ||
                response.status === 401 ||
                response.status === 404 ||
                response.status === 403) {
                return;
            }

            let request = error.request;

            if (!window.config.isLocal) {
                Sentry.withScope(function (scope) {
                    scope.setExtra("req", JSON.stringify(request))
                    scope.setExtra("res", JSON.stringify(response));
                    Sentry.captureMessage(`${response.status} Error`, 'error')
                });
            }

        }
        catch(e){
            console.error(e);
        }
    }

    error(message){

        if (message == null){
            return;
        }

        console.error(message);

        try{
            if (!window.config.isLocal) {

                let context = {
                    level: "Error"
                }


                if (typeof message === "string")
                {
                    Sentry.captureMessage(message,  context);
                }
                else if(typeof message === "object"){
                    Sentry.captureException(message, context);
                }
                else{
                    Sentry.captureMessage(message,  context);
                }

            }
        }
        catch(error){
            console.error(error);
        }
    }

    /**
     * Writes a warning message
     * @param message
     */
    warn(message){
        console.warn(message);

        try{
            if (!window.config.isLocal) {

                let context = {
                    level: "Warning"
                }

                if (typeof message === "string")
                {
                    Sentry.captureMessage(message, context);
                }
                else if(typeof message === "object"){
                    Sentry.captureException(message, context);
                }
                else{
                    Sentry.captureMessage(message, context);
                }

            }
        }
        catch(error){
            console.error(error);
        }
    }

    /**
     * Writes a warning message
     * @param message
     */
    warning(message){
        this.warn(message);
    }

    /**
     * Writes a debug message
     * @param message
     */
    debug(message){
        if (window.config.environment !== 'production') {
            console.debug(message);
        }
    }

    /**
     * Writes a information message
     * @param message
     */
    info(message){
        console.info(message);
    }

    verbose(message){
        if (window.config.isLocal) {
            console.debug(message);
        }
    }

    /**
     * Gets the current tracer instance.
     * @returns {Tracer|*}
     */
    static get current() {

        if (window.tracer == null){
            window.tracer = new Tracer();
        }

        return window.tracer;
    }
}